import { useState } from 'react';

import CreateGoalPanel from 'components/MeshList/goals/CreateGoalPanel';
import ObjectiveSidePanel from 'components/ObjectiveSidePanel';
import { useSelector } from 'react-redux';
import { selectLoggedInEmployeeData } from 'selectors/loggedInEmployee';

export const OKRSidePanels = ({
  isOpenCreateGoalPanel,
  setIsOpenCreateGoalPanel,
  isOpenCreateObjectivePanel,
  setIsOpenCreateObjectivePanel,
  selectedTimelines,
  afterGoalCreation,
}) => {
  const loggedInEmployee = useSelector(selectLoggedInEmployeeData);
  const [isGoalPanelOfCreatedObjective, setIsGoalPanelOfCreatedObjective] = useState(false);
  // timebound details of newly created objective
  const [timeboundDetailsOfCreatedObjective, setTimeboundDetailsOfCreatedObjective] = useState(null);

  return (
    <>
      {/* @ts-expect-error missing goalListDispatch */}
      <CreateGoalPanel
        open={isOpenCreateGoalPanel}
        onCancel={() => {
          setIsOpenCreateGoalPanel(false);
        }}
        employee={loggedInEmployee}
        // defaultTask={defaultCreateTask}
        subObjective={isGoalPanelOfCreatedObjective ? { ...timeboundDetailsOfCreatedObjective } : null}
        source="teampage"
        eventSource="Team Page"
        selectedTimeBoundPeriod={selectedTimelines?.[0] ?? null}
        afterGoalCreation={afterGoalCreation}
      />
      {/* @ts-expect-error more missing non-mandatory props */}
      <ObjectiveSidePanel
        open={isOpenCreateObjectivePanel}
        onCancel={() => {
          setTimeboundDetailsOfCreatedObjective(null);
          setIsGoalPanelOfCreatedObjective(false);
          setIsOpenCreateObjectivePanel(false);
        }}
        selectedTimeBoundPeriod={selectedTimelines?.[0] ?? null}
        isAlignmentAtParentLevel
        setIsOpenCreateGoalPanel={(value) => {
          setIsOpenCreateGoalPanel(value);
          setIsGoalPanelOfCreatedObjective(value);
        }}
        setTimeboundDetailsOfCreatedObjective={setTimeboundDetailsOfCreatedObjective}
        source="Team Page"
      />
    </>
  );
};
